export default "__VITE_ASSET__C1Up1rT5__"